import VideoProvider from './hooks/useVideo';
import VideoContainer from './handles/VideoContainer';

import { VideoProps } from './@types/VideoProps';

const Video = (props: VideoProps) => (
	<VideoProvider {...props}>
		<VideoContainer></VideoContainer>
	</VideoProvider>
);

export default Video;
